import { render, staticRenderFns } from "./DeadlinesView.vue?vue&type=template&id=67085b7c&"
import script from "./DeadlinesView.vue?vue&type=script&lang=ts&"
export * from "./DeadlinesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports